import { useContext } from 'react'
import { IntlContext } from 'react-intl'

export const useFormatMessage = () => {
  const intl = useContext(IntlContext)
  return intl.formatMessage
}
